import isVisible from './is-dialog-visible';

export default {
  isVisible,
};
